import gql from "graphql-tag";

export const GET_CHAT_MESSAGES_PAGINATION_QUERY = gql`
  query ($chatId: Int!, $skip: Int!, $take: Int!) {
    getChatMessagesPaginated(
      data: { chatId: $chatId, pagination: { skip: $skip, take: $take } }
    ) {
      hasMore
      total
      items {
        id
        createdAt
        message
        userId
        user {
          id
          firstName
          lastName
          profilePhotoX64 {
            fullUri
          }
        }
        publication {
          id
          title
          description
          cover {
            id
            fullUri
          }
          author {
            id
            firstName
            lastName
            profilePhotoX64 {
              id
              fullUri
            }
            shortAbout
          }
        }
        publicationResource {
          id
          createdAt
          updatedAt
          type
          order
          content
          publicationId
          publicationSectionId
          medias {
            id
            title
            fullUri
            size
            mimeType
            aspectRatio
            duration
          }
          publication {
            id
            title
            description
            cover {
              id
              fullUri
            }
            author {
              id
              firstName
              lastName
              profilePhotoX64 {
                id
                fullUri
              }
              shortAbout
            }
          }
        }
        post {
          id
          text
          createdAt
          updatedAt
          privacy
          likesCount
          commentsCount
          like {
            postId
            userId
          }
          author {
            id
            firstName
            lastName
            shortAbout
            profilePhotoX64 {
              fullUri
            }
          }
          mediaItems {
            id
            order
            title
            size
            mimeType
            fullUri
            aspectRatio
            duration
            createdAt
          }
          publication {
            id
            title
            description
            cover {
              id
              fullUri
            }
            author {
              id
              firstName
              lastName
              profilePhotoX64 {
                id
                fullUri
              }
              shortAbout
            }
          }
          publicationResource {
            id
            createdAt
            updatedAt
            type
            order
            content
            publicationId
            publicationSectionId
            medias {
              id
              title
              fullUri
              size
              mimeType
              aspectRatio
              duration
            }
            publication {
              id
              title
              description
              cover {
                id
                fullUri
              }
              author {
                id
                firstName
                lastName
                profilePhotoX64 {
                  id
                  fullUri
                }
                shortAbout
              }
            }
          }
        }
      }
    }
  }
`;
